module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_20.fddc6446.mp3";